
define('text!templates/modules/profile/edit/preferences-edit-content.html',[],function () { return '<div class="panel-body" id="preferences-edit-content">\n    <ul class="menu-actions nav nav-pills"></ul>\n\n    <div class="alert-list"></div>\n    <div class="preferences-edit-form"></div>\n</div>\n';});

